<template>
    <mainComponent
            title="Tableau de bord"
    >
    </mainComponent>
</template>


<script>
    import mainComponent from '../mainComponent.vue'
    import {sortBy} from 'lodash'
    import toastr from 'toastr/build/toastr.min'
    import globalHelper from '../../services/helperService'
    import queryString from 'query-string'
    import appConfig from '../../config/app'

    export default {
        name: 'homeComponent',
        components: {mainComponent},
        data() {
            return {
                searchListReport: '',
                listLinks: []
            }
        },
        created() {
        },
        mounted() {
            let setParams1 = {
                "types[]": ["MHTHLP-Temps de conduite hlp","1-Commerciale"],
                "startDate": "2018-07-31T22:00:00.000Z"
            }
            let setParams2 = {
                "types[]": "1-Commerciale"
            }
            let params1 = {
                name: appConfig.routes.indicatorOtf,
                params: {
                    indicator: 'km',
                    filters: queryString.stringify(setParams1)

                }
            }
            let params2 = {
                name: appConfig.routes.indicatorOtf,
                params: {
                    indicator: 'km',
                    filters: queryString.stringify(setParams2),
                    nosearch: true
                }}

            this.listLinks.push({
                name: 'MHTHLP-Temps de conduite hlp',
                to: params1
            })
            this.listLinks.push({
                name: 'Commerciale (No auto Search)',
                to: params2
            })



        },
        methods: {
        },
        computed: {
        },
    }
</script>